import { MAX_OBSTACLE_ROUTING_NODES } from './edgeRouting';
import { VIEWPORT_CULLING_THRESHOLD } from './viewportCulling';

const ADAPTIVE_ROUTING_MIN = 25;

export function shouldUseBackgroundEdgeRouting(totalNodeCount, mountedNodeCount) {
  // Start at the synchronous solver's limit, even before viewport culling.
  return mountedNodeCount > MAX_OBSTACLE_ROUTING_NODES
    || (totalNodeCount > VIEWPORT_CULLING_THRESHOLD
      && mountedNodeCount >= ADAPTIVE_ROUTING_MIN);
}
